module.exports = __webpack_public_path__ + "img/3.6ab518e7.jpg";